import React from 'react';
import { Link } from 'gatsby';
import Helmet from 'react-helmet';
import Waypoint from 'react-waypoint';

import Layout from '../components/layout';
import Header from '../components/Header';
import Countdown from '../components/Countdown';
import Nav from '../components/Nav';
import Form from '../components/Form';
import favicon from '../assets/images/diamond-ring.png';

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			stickyNav: false
		};
	}

	_handleWaypointEnter = () => {
		this.setState(() => ({ stickyNav: false }));
	};

	_handleWaypointLeave = () => {
		this.setState(() => ({ stickyNav: true }));
	};

	render() {
		//const Form = require('../components/Form').default

		return (
			<Layout>
				<Helmet
					title="Carly & Daniel Wedding"
					link={[ { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` } ]}
				/>

				<Header />

				<Waypoint onEnter={this._handleWaypointEnter} onLeave={this._handleWaypointLeave} />
				<Nav sticky={this.state.stickyNav} />

				<div id="main">
					<section id="countdown">
						<Countdown />
					</section>

					<section id="our-story" className="main special">
						<header className="major">
							<h2>Our Story</h2>
							<p>
								Carly and Daniel met in November 2014 when Carly started her first day as a hostess at
								The Keg Steakhouse and Bar where Daniel had been working for a couple years. While Carly
								and Daniel didn't talk to each other very much for the first year of working together,
								their coworkers decided that they would make a great couple. After a couple of weeks of
								not-so-subtle hints from coworkers and friends, Carly and Daniel went on their first
								date on January 24th, 2016 where Carly impressed him with her incredible Top Golf
								skills, Daniel asked Carly to be his girlfriend two days later. After almost three years
								of dating, Carly and Daniel decided it's time to tie the knot! <br />
								<br />We are so excited to move onto the next chapter of our lives together and we can't
								wait to share our wedding day with our closest friends and family. We hope to see you on
								June 15th, 2019!
							</p>
						</header>
					</section>

					<section id="details" className="main special">
						<header className="major">
							<h2>Details</h2>
						</header>
						<ul className="features">
							<li>
								<span className="icon major style1 fa-map-pin" />
								<h3>Location</h3>
								<p>
									The Villa Tuscana Reception Hall is located at 1915 West Guadalupe Road Mesa,
									Arizona, 85202.
								</p>
								<a
									className="button special"
									href="https://goo.gl/maps/LK1VtQYb3H12"
									target="_blank"
									rel="noopener norefferer"
								>
									Map
								</a>
							</li>
							<li>
								<span className="icon major style1 fa-calendar" />
								<h3>Date & Time</h3>
								<p>
									The ceremony will begin at 4:00 PM. Please arrive 10 to 15 minutes early. The
									reception will be held until 10:00 PM.
								</p>
								<a
									className="button special"
									href="https://s3.amazonaws.com/danielsrandom/Daniel_Carly_Wedding.ics"
									download="carly-daniel-wedding.ics"
								>
									Add to Calendar
								</a>
							</li>
							<li>
								<span className="icon major style1 fa-hotel" />
								<h3>Hotel Recommendations</h3>
								<p>
									If you're traveling to Arizona for the wedding, you can find one of the closest
									hotels to the venue here.
								</p>
								<a
									className="button special"
									href="https://www.marriott.com/hotels/travel/phxrm-residence-inn-phoenix-mesa/?scid=bb1a189a-fec3-4d19-a255-54ba596febe2"
									target="_blank"
									rel="noopener norefferer"
								>
									Hotel
								</a>
							</li>
							<li>
								<span className="icon alt style2 fa-glass" />
								<h3>Dress Code</h3>
								<p>Please arrive in formal attire.</p>
							</li>
						</ul>
					</section>

					<section id="rsvp" className="main special">
						<header className="major">
							<h2>RSVP</h2>
							<p>Please respond by May 1st </p>
						</header>
						<Form />
					</section>
					<section id="registry" className="main special">
						<header className="major">
							<h2>Registry</h2>
							<p>
								Your attendance is all we hope for <br />
								but if you'd like you can visit our registry here!
							</p>
						</header>
						<footer className="major">
							<ul className="actions">
								<li>
									<a
										className="button special"
										href="https://www.bedbathandbeyond.com/store/giftregistry/viewregistryguest/546884035?eventType=Wedding"
										target="_blank"
										rel="noopener norefferer"
									>
										Information
									</a>
								</li>
							</ul>
						</footer>
					</section>
				</div>
			</Layout>
		);
	}
}

export default Index;
